var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['icon-container', _vm.position === 'top'?'position-top':''],on:{"click":_vm.onClick}},[_c('div',{staticClass:"icon-inner"},[_c('icon-svg',{staticClass:"icon",attrs:{"icon-class":_vm.iconName}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }